export const subtitles = {
    "1": {
        "startTime": 14.78,
        "endTime": 17.34,
        "transcript": "Tua-i-qaa? (Ii-i.) Ii-i.",
        "translation": "Now? Okay."
    },
    "2": {
        "startTime": 17.545,
        "endTime": 25.315,
        "transcript": "Tua-i wangkuta imumi qasgimi, tan'gaurlurni qasgimi uitauratullruukut",
        "translation": "A long time ago in the qasgiq, young men like us stayed in the qasgiq"
    },
    "3": {
        "startTime": 25.315,
        "endTime": 31.455,
        "transcript": "Imkut yuut taqneret ilagarluki qasgimi uitauralriit.",
        "translation": "We stayed with all the adults who lived in the qasgiq"
    },
    "4": {
        "startTime": 31.9,
        "endTime": 38.33,
        "transcript": "Ukugnek tang tau͡gaam qaneryarangqetulriit Yuut",
        "translation": "These were what those elders talked about most"
    },
    "5": {
        "startTime": 38.88,
        "endTime": 46.79,
        "transcript": "Yuum pingnaqellranek, cali-llu kaigluni neqkaunani pillerkamek.",
        "translation": "Of people striving to survive, and of going hungry with no food to eat."
    },
    "6": {
        "startTime": 46.79,
        "endTime": 50.05,
        "transcript": "Tamakunek qanruquratullruitkut.",
        "translation": "They talked to us about those many times."
    },
    "7": {
        "startTime": 50.055,
        "endTime": 59.055,
        "transcript": "Cali-llu pingnatukumta, yuilqumi-llu pingnatukumta ilaput ikayuasqekait.",
        "translation": "Also if we are struggling, out there while hunting and gathering, to help others."
    },
    "8": {
        "startTime": 59.28,
        "endTime": 65.14,
        "transcript": "Tua-i arcaqerluku waniwa pingayun ukut wani alerquutnguut",
        "translation": "These 3 especially are rules to follow"
    },
    "9": {
        "startTime": 65.145,
        "endTime": 68.005,
        "transcript": "Wii niiqurlallemni:",
        "translation": "This is what I heard:"
    },
    "10": {
        "startTime": 68.69,
        "endTime": 76.98,
        "transcript": "Yuilqumi-gguq tarrisnginanemni ilamnek arenqiallugtellriamek tangerquma",
        "translation": "If I come across someone in trouble while traveling"
    },
    "11": {
        "startTime": 76.98,
        "endTime": 80.54,
        "transcript": "Pirrangqertacimtun ikayuakilaku.",
        "translation": "I am to help them out as much as I can  with what I have."
    },
    "12": {
        "startTime": 80.54,
        "endTime": 90.47,
        "transcript": "Alerquumaluta tuaten. Wall'u imarkailkan wall'u neqkailkan neqkarramnek tuaken avgutesqelluku.",
        "translation": "We were advised that way. If they don't have ammunition or food to eat, to share what I have with them."
    },
    "13": {
        "startTime": 91.13,
        "endTime": 103.48,
        "transcript": "Cali-llu pilaraitkut waten-wa: waniwa-gguq atam cam iliini, ertem iliini pikailkumta",
        "translation": "They also told us like this: some day when we have nothing"
    },
    "14": {
        "startTime": 103.48,
        "endTime": 114.74,
        "transcript": "Waten pikailkumta uninraarturngaitukut. Anrutam-gguq qam'um imaitellra anglanarqenritut.",
        "translation": "They told us that an empty stomach is no fun."
    },
    "15": {
        "startTime": 115.085,
        "endTime": 122.165,
        "transcript": "Yuum-gguq tamarmi ayuqucian nangteqsaram",
        "translation": "Of all things that a person suffers,"
    },
    "16": {
        "startTime": 122.177,
        "endTime": 129.247,
        "transcript": "Angenqaa anrutam qam'um imaunani nangtequtekellra.",
        "translation": "Nothing compares to the pain of an empty stomach."
    },
    "17": {
        "startTime": 129.257,
        "endTime": 133.937,
        "transcript": "Pinirnaunani uninraarnaunani-llu.",
        "translation": "A person who is hungry cannot be strong."
    },
    "18": {
        "startTime": 134.301,
        "endTime": 147.348,
        "transcript": "Cali-llu neqa elliin imna neqa cenkenritqallrullni wall'u neqa egtellrukuniu nernarqengraan",
        "translation": "Also if a person has wasted some food in the past or thrown away some food"
    },
    "19": {
        "startTime": 147.519,
        "endTime": 154.039,
        "transcript": "Tailuni umyugaanun tailuni uurcaraluni arenqiapaa.",
        "translation": "The thought of that will haunt a person and he will regret “Arenqiapaa (unhappy exclamation like oh no or too bad.)"
    },
    "20": {
        "startTime": 154.045,
        "endTime": 158.835,
        "transcript": "\"Imna-llu kitak' nerurallrulaku egtevkenaku.\"",
        "translation": "“I should've ate that food and not thrown it away!”"
    },
    "21": {
        "startTime": 158.84,
        "endTime": 162.83,
        "transcript": "Tuaten-gguq atam ayuquq.",
        "translation": "They said that is how it is."
    },
    "22": {
        "startTime": 163.289,
        "endTime": 170.729,
        "transcript": "Ca-gguq tamalkuan umyuamikun aglumayagulluku waten kaigluni.",
        "translation": "In his mind everything starts looking good enough to eat because he is so hungry."
    },
    "23": {
        "startTime": 170.982,
        "endTime": 178.842,
        "transcript": "Maa-i makut wani arcaqerluki wangkuta qanruyutektuaput.",
        "translation": "These things especially were taught to us."
    },
    "24": {
        "startTime": 179.077,
        "endTime": 194.477,
        "transcript": "Cali-llu uksumi waten nenglem nalliini angussaagaqamta nutaan cakviutuamta",
        "translation": "Also in the winter, during the cold weather when we are hunting, that is when we struggle."
    },
    "25": {
        "startTime": 195.656,
        "endTime": 199.326,
        "transcript": "Tua-i caunata ayaasqevkenata.",
        "translation": "They told us not to travel empty handed."
    },
    "26": {
        "startTime": 199.491,
        "endTime": 205.888,
        "transcript": "Qanikciurutaunata cikuliurutaunata-llu ayaasqevkenata.",
        "translation": "They told us to never travel without a shovel and an ice pick."
    },
    "27": {
        "startTime": 206.5,
        "endTime": 214.176,
        "transcript": "Cali-llu makut kuiget atrit atengqertelluki.",
        "translation": "Also to have names for rivers and creeks."
    },
    "28": {
        "startTime": 214.691,
        "endTime": 228.102,
        "transcript": "Yuum-gguq atam iliin pikaitem nalliini taum-llu neq'rugalgem nuniini nangernganiartuq atra nallukuniu.",
        "translation": "They said that a person, during a time of want, will stand by a river or creek that has a lot of fish and not know it if they don't know the name of the place."
    },
    "29": {
        "startTime": 228.339,
        "endTime": 239.509,
        "transcript": "Taumek maa-i yuilqumi pingnatugyarat tamalkuita acirturluki piuratulliniit imkut yuut",
        "translation": "That is why our ancestors named all their hunting places"
    },
    "30": {
        "startTime": 239.901,
        "endTime": 243.711,
        "transcript": "Nernarqellriit neqait ayuqenrilnguut.",
        "translation": "Places with different kinds of food or fish."
    },
    "31": {
        "startTime": 243.867,
        "endTime": 252.807,
        "transcript": "Yuum-gguq atra nallukuniu taum kuigem apertuumangraan neqengqerrucia nallua.",
        "translation": "If a person doesn't know that name of a river, he will not know if that place has fish."
    },
    "32": {
        "startTime": 253.552,
        "endTime": 263.83,
        "transcript": "Taumek qanrucimaukut nunam-gguq qaingani kuiget-llu nanvarraat-llu atrit cali elisnganarqaput",
        "translation": "That is why we are told to learn all place names of rivers and lakes."
    },
    "33": {
        "startTime": 263.875,
        "endTime": 271.605,
        "transcript": "Angussaagyarat, nerengnaqsarat, makut maa-i qanruyutektuaput.",
        "translation": "Places where we hunt for food, these are what was taught to us."
    },
    "34": {
        "startTime": 271.611,
        "endTime": 279.931,
        "transcript": "Tau͡gken neqaicuilnguut aperturluki cali.",
        "translation": "Also to know which lakes and rivers always have food."
    },
    "35": {
        "startTime": 280.176,
        "endTime": 283.836,
        "transcript": "\"Qamna-gguq qama-i Ecuilnguq neqaicuituq.\"",
        "translation": "That place upriver “Ecuilnguq” always has fish."
    },
    "36": {
        "startTime": 284.139,
        "endTime": 290.669,
        "transcript": "\"Cali-llu niitetuaqa Qagatmiut-gguq pamna au͡gatii neqaicuituq.\"",
        "translation": "Also I hear “Qagatmiut” area above us i always has fish."
    },
    "37": {
        "startTime": 290.985,
        "endTime": 300.845,
        "transcript": "Ingrit-gguq makut carvanilriit, maaken ingrinek carvanilria neqem-gguq caumanriyuitaa.",
        "translation": "They taught us that streams with a strong current that flow from the mountains always have fish."
    },
    "38": {
        "startTime": 300.852,
        "endTime": 310.052,
        "transcript": "Nalayuituq-gguq uksumi caumararqamiu qallalluni waten pilria",
        "translation": "A person will survive if they stay with streams or rivers with strong “boiling” currents"
    },
    "39": {
        "startTime": 311.45,
        "endTime": 322.938,
        "transcript": "Tamakut ullagluki nallunrilkumteki wall'u manarluta wall'u kuvyirluta avungnaquraasqelluta pilaraitkut.",
        "translation": "If we know of places like that we can fish with hook and line or use a net to try to survive,  that is what they told us."
    },
    "40": {
        "startTime": 323.771,
        "endTime": 336.371,
        "transcript": "Man'a-gguq Kuigpak man'a un'a men'i ecuriaqan, mer'a ecuriaqan kuignun ecuilngurnun neqet itetuut.",
        "translation": "They told us that when the water in the  Yukon river becomes dark, fish move to clearer waters, fish  enter clearer rivers."
    },
    "41": {
        "startTime": 336.962,
        "endTime": 343.702,
        "transcript": "Unuunge'rmi Kuigpagmi neqai nalatuameng neqairulluni.",
        "translation": "Even these Yukon river fish die till there is no more fish."
    },
    "42": {
        "startTime": 344.081,
        "endTime": 353.881,
        "transcript": "Tua-i-ll' neqairutaqan uitavkenata cali can'giilegnun ayagluta, can'giirturyaranun.",
        "translation": "And then when there is no more fish, they told us not to stay but to go to places that have black fish, places where black fish traps are set."
    },
    "43": {
        "startTime": 353.893,
        "endTime": 357.343,
        "transcript": "Cali tamaavet angungnaquraasqelluta.",
        "translation": "They told us also to go and try to survive at those places."
    },
    "44": {
        "startTime": 357.559,
        "endTime": 369.139,
        "transcript": "Qimugterrlainaput piyuitellruaput. Wangkuta tuaten neqkamteńek angussaatullruukut ayagaluta.",
        "translation": "We not only hunted for our dog teams, we also hunted for ourselves."
    },
    "45": {
        "startTime": 369.142,
        "endTime": 377.672,
        "transcript": "Makut-gguq nallutailnguut: kaviaret tulukaruut-llu.",
        "translation": "They told us that these foxes and ravens are smart."
    },
    "46": {
        "startTime": 377.684,
        "endTime": 387.934,
        "transcript": "Neqengqerraqan-gguq tua-i tauna taum tua-i kaviarem apertutua tulukaruum-llu. Tua-i-wa nallutailnguut.",
        "translation": "A fox and a raven will show you where there is food or fish, because there is nothing they don't know."
    },
    "47": {
        "startTime": 388.044,
        "endTime": 399.164,
        "transcript": "Tamakut-am cali tamaani alerquumaluta murilkuraasqelluki tamakut kaviaret tamakut-llu makut tulukaruut.",
        "translation": "They also told us to be watchful of foxes and ravens."
    },
    "48": {
        "startTime": 399.262,
        "endTime": 401.612,
        "transcript": "Maa-i tang qanruyuteput.",
        "translation": "These things are what was taught to us."
    },
    "49": {
        "startTime": 402.544,
        "endTime": 411.639,
        "transcript": "Ilumun kaviaret neqnek aperturituut. Tulukaruut-llu cali aperturituut.",
        "translation": "It is true that foxes show where there are fish. Ravens also show where there is food."
    },
    "50": {
        "startTime": 411.813,
        "endTime": 419.353,
        "transcript": "Maaten ullagnaurput ik'iki can'giiret, tua-i-llu taluyirluta.",
        "translation": "If we go to places where  foxes and ravens are, there is so much blackfish, then that is where we set our blackfish trap."
    },
    "51": {
        "startTime": 419.701,
        "endTime": 426.681,
        "transcript": "Amllengraan cali unakesqelluku, amlleringraan, amlleriyukengramteggu.",
        "translation": "They also told us if to catch enough"
    },
    "52": {
        "startTime": 426.689,
        "endTime": 430.109,
        "transcript": "Ilaput umyuaqluki pisqelluku.",
        "translation": "And to think of our communities."
    },
    "53": {
        "startTime": 431.12,
        "endTime": 441.689,
        "transcript": "Imkut yuut yuullermeggni kenkutellruut. Kenka pikellruat. Kenkulluteng.",
        "translation": "Those people when  they were alive, they had love for each other. Love was their way. They loved each other."
    },
    "54": {
        "startTime": 441.903,
        "endTime": 450.339,
        "transcript": "Ilateng-llu cikirnaurait akilirpek'naki, cimi'irkaitnek-llu piyugnaunateng.",
        "translation": "They gave to each other without asking for payment, without asking for anything in return."
    },
    "55": {
        "startTime": 450.678,
        "endTime": 458.671,
        "transcript": "Tua-i cam iliini atam arenqiallugtelleq amllerrami wangkutni",
        "translation": "Sometimes troubles are many among us"
    },
    "56": {
        "startTime": 458.927,
        "endTime": 464.688,
        "transcript": "Iliini arenqiallugtellriani aptellriani qanernaurtuq",
        "translation": "Sometimes when we have a problem and ask for help, they tell us"
    },
    "57": {
        "startTime": 464.743,
        "endTime": 472.114,
        "transcript": "\"Imumi wiinga-ll' nanikuaqallemni ikayullruavnga waniw' pikangqertacirramtun ikayuramken.\"",
        "translation": "“You helped me during a time when I needed help so now I am helping you as much as I can.”"
    },
    "58": {
        "startTime": 472.126,
        "endTime": 476.826,
        "transcript": "Inglukucugnaunateng kenkulluteng.",
        "translation": "They were not against each other, they loved each other."
    },
    "59": {
        "startTime": 476.837,
        "endTime": 481.097,
        "transcript": "Tua-i waten qanrutetullruatnga wiinga.",
        "translation": "This is what they told me."
    },
    "60": {
        "startTime": 481.464,
        "endTime": 482.564,
        "transcript": "Tua-i-qaa?",
        "translation": "Is that all?"
    },
    "61": {
        "startTime": 485.055,
        "endTime": 488.245,
        "transcript": "Yaa, amllerciquq.",
        "translation": "Yes. It will be enough."
    }
};